import { UseCashbackFormParams, UseCashbackFormReturn } from "./types";
import { useCashbackEarned } from "./useCashbackEarned";

export const useCashbackForm = (
  params: UseCashbackFormParams,
): UseCashbackFormReturn => {
  const earned = useCashbackEarned(params);
  return {
    cashbackEarnedLabel: earned.cashbackEarnedLabel,
    cashbackEarnedHelper: earned.cashbackEarnedHelper,
    cashbackPrefillError: earned.error,
    isCashbackPrefillPending: earned.isPending,
  };
};
